import { Link } from "react-router-dom";
import { Field, Choice, Check, StepTitle, inputCls } from "@/components/register/Fields";

const HEARD = ["Instagram", "Facebook", "Friend or family", "School", "Club or coach", "Google", "Other"];
const YESNO = [{ value: true, label: "Yes, I consent" }, { value: false, label: "No, I don't consent" }];

export const StepConsent = ({ player, setConsent, parent, setParent, errors, showHeard }) => {
  const c = player.consent;
  return (
    <div data-testid="step-consent">
      <StepTitle eyebrow={`${player.first_name || "Player"} · Step 5`} title="Consent & agreement" />
      <div className="space-y-7">
        {showHeard && (
          <Field label="How did you find us?">
            <select data-testid="consent-heard-about" className={inputCls} value={parent.heard_about} onChange={(e) => setParent("heard_about", e.target.value)}>
              <option value="">Select…</option>
              {HEARD.map((h) => <option key={h} value={h}>{h}</option>)}
            </select>
          </Field>
        )}
        <p className="text-sm text-slate-400" data-testid="consent-photo-optional-note">Photography and video consent is optional — choosing “No” does not affect registration.</p>
        <Field label="Photos & video on social media (optional)" error={errors.photo_social} hint="Images of your child may appear on our Instagram and Facebook.">
          <Choice testid="consent-photo-social" value={c.photo_social} onChange={(v) => setConsent("photo_social", v)} options={YESNO} />
        </Field>
        <Field label="Photos & video in advertising (optional)" error={errors.photo_ads} hint="Images of your child may be used in paid advertising.">
          <Choice testid="consent-photo-ads" value={c.photo_ads} onChange={(v) => setConsent("photo_ads", v)} options={YESNO} />
        </Field>
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5">
          <Check testid="consent-guardian" checked={c.guardian_confirmed} error={errors.guardian_confirmed} onChange={(v) => setConsent("guardian_confirmed", v)}>
            I confirm I am the parent or legal guardian of this player and the information provided is correct.
          </Check>
          <Check testid="consent-medical-treatment" checked={c.medical_treatment_authorised} error={errors.medical_treatment_authorised} onChange={(v) => setConsent("medical_treatment_authorised", v)}>
            I authorise Elite Performance Lab staff to obtain emergency medical treatment for my child, including first aid and ambulance transport, if I or the emergency contact cannot be reached.
          </Check>
          <Check testid="consent-terms" checked={c.terms_accepted} error={errors.terms_accepted} onChange={(v) => setConsent("terms_accepted", v)}>
            I agree to the participation <Link to="/terms" target="_blank" className="accent-text underline">Terms & Conditions</Link>, including the <Link to="/refund-policy" target="_blank" className="accent-text underline">Refund & Cancellation Policy</Link>.
          </Check>
          <Check testid="consent-privacy" checked={c.privacy_accepted} error={errors.privacy_accepted} onChange={(v) => setConsent("privacy_accepted", v)}>
            I accept the <Link to="/privacy" target="_blank" className="accent-text underline">Privacy Policy</Link>.
          </Check>
        </div>
        <p className="text-xs text-slate-500">Your selections are recorded with a timestamp and policy version.</p>
      </div>
    </div>
  );
};
